import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.session-recording', {
        url: '/session-recording',
        component: 'companyManageApplicationSessionRecording',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/session-recording/session-recording.state.js